import { render, staticRenderFns } from "./CategoryDropdownMenu.vue?vue&type=template&id=165efac0&scoped=true&"
import script from "./CategoryDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDropdownMenu.vue?vue&type=style&index=0&id=165efac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165efac0",
  null
  
)

export default component.exports